<template>
  <component :is="layout"></component>
</template>

<script lang="ts">
import Vue from 'vue';
import LoggedContainer from '@/views/layouts/containers/LoggedContainer.vue';
import GuestContainer from '@/views/layouts/containers/GuestContainer.vue';
import {UserProfile} from '@/models/core/CoreState';
import LoadingContainer from '@/views/layouts/containers/LoadingContainer.vue';
import httpAxiosApi from "capitalist-shared/src/core/axios.errors.handle";

// import Component from "vue-class-component";

interface LayoutData {
  balance: Record<string, string>;
  profile: UserProfile;
}

// @Component({
//     name: "SmartLoggedGuestContainer",
//     // functional: true,
//     render(createElement, context) {
//
//         return createElement(
//             this.isLogged ? LoggedContainer : GuestContainer,
//             context.data,
//             context.children
//         )
//
//     }
// })
// export default class SmartLoggedGuestContainer extends Vue {}

export default Vue.extend({
  name: 'SmartLoggedGuestContainer',
  data(): any {
    return {
      loaded: false,
    };
  },
  computed: {
    isLoaded(): boolean {
      return this.loaded;
    },
    isLogged(): boolean {
      return this.$store.state.user.isLogged();
    },
    isGuest(): boolean {
      return !this.$store.state.user.isLogged();
    },
    layout(): any {
      if (!this.loaded) return LoadingContainer;
      return this.isLogged ? LoggedContainer : GuestContainer;
    },
  },
  mounted() {
    httpAxiosApi.post('/webapi/webapi/layout').then((response) => {
      const data = response.data as LayoutData;
      this.$store.state.layout.balance = data.balance;
      this.$store.state.user.login(data.profile as UserProfile);
      this.loaded = true;
    }, (err) => {
      this.loaded = true;
      throw err;
    });
  },
  // render(createElement, context): VNode {
  //
  //     return createElement(
  //         this.isLogged ? LoggedContainer : GuestContainer,
  //         context.data,
  //         context.children
  //     );
  //
  // }
});
// export default class SmartLoggedGuestContainer extends Vue {}
</script>

<style scoped>

</style>
